import React, {Component} from 'react';
import Styles from './styles/letterStyles';
const letters=["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
class AToZLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      anchor:[]
    };
  }
  
    makeLink(letter, index){
        
        const aStyles={textDecoration:"none"}
        const nolinkStyles={color:window.innerWidth>899?"":"#444"}
        const anchor = '#'+letter+this.props.letters[this.props.letters.length-1];
        if (this.props.letters.indexOf(letter)!==-1){
          return ( <li key={index} className={letter+' link'} style={Styles.liStyles}><a style={aStyles} href={anchor} className='tab' tabIndex='0'>{letter}</a></li>);
        }else{
          return (<li key={index} style={{...Styles.liStyles,...nolinkStyles}} className={letter+' nolink'}><span>{letter}</span></li>);  
        }
    }
    makeLinks(){

        return letters.map((item, index) => (
          this.makeLink(item, index)
        ));
    }
    
    render(){
      
        return(
            <div className='atz' id="ATZ"><ul style={{listStyleType:" none"}}>{this.makeLinks()}</ul></div>

        );
    }


}

export default AToZLinks;